import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// 引入 Swiper 样式文件
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper)